import { BasicEvent } from "./BasicEvent";

export class MinaMaskinlagUpdatedEventMessage extends BasicEvent {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "MinaMaskinlagUpdatedEventMessage";
    constructor() {
        super(MinaMaskinlagUpdatedEventMessage.$type);
    }
}
